import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { CONNEXION } from "@shared/constants/route.constants";
import { AuthenticationService } from "@shared/services/authentication.service";

@Component({
  selector: "app-page-not-found",
  standalone: true,
  templateUrl: "./page-not-found.component.html",
  imports: [TranslateModule],
})
export class PageNotFoundComponent implements OnInit {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit() {
    if (!this.authenticationService.isLoggedIn()) {
      this.router.navigate([CONNEXION]);
    }
  }
}
